import React, { Component } from 'react';
import { Link } from 'react-router';
import './HeaderLinks.css';

export default class HeaderLinks extends Component {

  renderLoggedOut() {
    return (
      <div className="links-container">
        <Link to='/signin' className="header-link-text" activeStyle={{ opacity: 1 }}>
          Sign In
        </Link>
      </div>
    )
  }

  renderLoggedIn() {
    return (
      <div className="links-container">
        <div className="header-link-text"
          onClick={this.props.auth.logout}>
          Sign out
        </div>
      </div>
    )
  }

  render() {
    return this.props.auth.loggedIn()
      ? this.renderLoggedIn()
      : this.renderLoggedOut()
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/HeaderLinks.jsx